module.exports = __webpack_public_path__ + "img/safari.2adb9627.svg";